import React from "react";
import "../../css/CRUDModal.css";

const CustMainWalletAuditModal = ({
  show,
  handleClose,
  walletTitle,
  auditData,
}) => {
  const handleBack = () => {
    handleClose();
  };
  console.log("auditData", auditData);
  const tableData = [
    { label: "Company Name", value: auditData?.name || "-" },
    { label: "Company Code", value: auditData?.userCode || "-" },
    { label: "Created By", value: auditData?.createdBy || "-" },
    { label: "Created Date", value: auditData?.createdDate || "-" },
    { label: "Checked By", value: auditData?.checkedBy || "-" },
    {
      label: "Checked Date",
      value:
        auditData?.checkedBy === null ? "-" : auditData?.checkedDate ?? "-",
    },
    { label: "Authorized By", value: auditData?.authBy || "-" },
    {
      label: "Authorized Date",
      value: auditData?.authBy === null ? "-" : auditData?.authDate ?? "-",
    },
    { label: "Modified By", value: auditData?.modifyBy || "-" },
    {
      label: "Modified Date",
      value: auditData?.modifyBy === null ? "-" : auditData?.modifyDt ?? "-",
    },
  ];

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "500px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Audit Trial</h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <table className="custom-table" style={{ width: "100%" }}>
                    <tbody>
                      {tableData.map((row, idx) => (
                        <tr
                          key={idx}
                          style={{ borderBottom: "1px solid #dee2e6" }}
                        >
                          <th
                            style={{
                              textAlign: "left",
                              padding: "8px",
                              backgroundColor: "#f8f9fa",
                              width: "40%",
                              fontWeight: 600,
                            }}
                          >
                            {row.label}
                          </th>
                          <td style={{ padding: "8px" }}>{row.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustMainWalletAuditModal;
